import ConnectAppRow from '@/components/ContextCard/ConnectAppRow'
import { titleFromSlug } from '@/hooks/titleFromSlug'

export default function IntegrationAccessGroups({
  groups,
  connectingToolkit,
  onConnect,
  deferred,
}) {
  return groups.map((group) => {
    const connected = group.connection_status === 'ACTIVE' && !group.connection_unusable
    const connecting = connectingToolkit === group.toolkit_slug
    const state = connected ? 'connected' : connecting ? 'working' : 'idle'
    return (
      <ConnectAppRow
        key={group.id ?? group.toolkit_slug}
        app={titleFromSlug(group.toolkit_slug)}
        slug={group.toolkit_slug}
        state={state}
        disabled={deferred || connecting}
        onClick={() => onConnect(group.toolkit_slug)}
      />
    )
  })
}
